import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { times } from 'lodash'

export const ConversationItemSkeleton = () => {
  return (
    <Box>
      {times(4, (index) => (
        <Box
          key={index}
          background="grey000White"
          paddingY="s12"
          paddingX="s16"
          gap="s4"
          border={{
            bottom: {
              color: 'grey400',
              width: 's1',
              style: 'solid',
            },
          }}
        >
          <Box flexDirection="column" gap="s12">
            <Box
              flexDirection="row"
              gap="s24"
              justifyContent="spaceBetween"
              alignItems="flexStart"
              width="full"
            >
              <Box gap="s8" flexDirection="column" width="full">
                <Skeleton height="s20" isLoading width="full" />
                <Skeleton height="s20" width="s120" isLoading />
              </Box>
              <Skeleton height="s24" isLoading width="s120" />
            </Box>
            <Skeleton height="s48" isLoading width="full" />
          </Box>
        </Box>
      ))}
    </Box>
  )
}
